import { IFirestoreUserRedemptionCodeRequestRepository } from "../../../cloudServices/googleFirebaseServices/database/firestore/FirestoreUserRedemptionCodeRequestRepository";
import { FirestoreDataRepositoryFactory } from "../../../cloudServices/googleFirebaseServices/database/firestore/FirestoreDataRepositoryFactory";
import { enumFirestoreDataRepositoryDataType } from "../../../cloudServices/googleFirebaseServices/database/firestore/enums";
import { IFirestoreBaseRepository } from "../../../cloudServices/googleFirebaseServices/database/firestore/FirestoreBaseRepository";
import { IUserRedemptionCodeRequest, IUserRedemptionCodeRequestAsJson } from "../../../../dataObjects/models/userRedemptionCodeRequest";


export function deleteUserRedemptionCodeRequest(userRedemptionCodeRequest: IUserRedemptionCodeRequest): Promise<void> {
  return new Promise<void>(async (resolve, reject) => {
    try {
      // get a UserRedemptionCodeRequest repository from the repository factory
      const firestoreUserRedemptionCodeRequestRepository: IFirestoreUserRedemptionCodeRequestRepository =
        FirestoreDataRepositoryFactory.CreateDataRepository(enumFirestoreDataRepositoryDataType.UserRedemptionCodeRequest) as
        IFirestoreBaseRepository<IUserRedemptionCodeRequest, IUserRedemptionCodeRequestAsJson>;

      // call the repository delete() method to delete the object
      await firestoreUserRedemptionCodeRequestRepository.delete(userRedemptionCodeRequest.id);

      resolve();
    } catch (error: any) {
      reject(error);
    }
  });
}